import React from "react";
import CommonLayout from "../../components/Layouts/CommonLayout";
import Transaction from "../../components/TransactionFailed";

const TransactionFailedPage = () => {
  return <Transaction />;
};

export default TransactionFailedPage;
